import permissions from "./../../data/permissions"
export default [
    {
        name: "Orders",
        path: "orders",
        component: () => import("./../../views/warehouse/OrdersListView.vue"),
        meta: { requiresAuth: true, authorization: permissions.purchase_order.index}

    },
    {
        name: "Order",
        path: "order/:id",
        component: () => import("./../../views/warehouse/OrderDisplayView.vue"),
        meta: { requiresAuth: true, authorization: permissions.purchase_order.read}
    },
   
]